const baseUrl = process.env.REACT_APP_URL || 'http://localhost/api'
const setHeaders = () => {
    return (
        {
            'Content-Type': 'application/json',
            'orgid': localStorage.getItem("organizationid") ?? ""
        }
    )
}
export const fetchCalendarsByOrganisationID = async (id: string) => {
    try {
        const apiUrl = `${baseUrl}/calendar/organisation/${id}`
        const response = await fetch(apiUrl, { method: 'GET', headers: setHeaders() });
        if (response.status) {
            return (await response.json())?.data
        }
    } catch (error) {
        console.log(error)
    }
}




export const fetchCalendarDetailsBy = async (id: string) => {
    try {
        const apiUrl = `${baseUrl}/calendar/${id}`
        const response = await fetch(apiUrl, { method: 'GET', headers: setHeaders() });
        if (response.status) {
            return (await response.json())?.data
        }
    } catch (error) {
        console.log(error)
    }
}

export const fetchCalendarTimeSlots = async (id: string, body: any) => {
    try {
        const apiUrl = `${baseUrl}/timeslot/calendar/${id}`
        const response = await fetch(apiUrl, { method: 'POST', headers: setHeaders(), body: JSON.stringify(body) });
        if (response.status) {
            return (await response.json())?.data
        }
    } catch (error) {
        console.log(error)
    }
}

export const fetchPriceByCalendar = async (id: string) => {
    try {
        const apiUrl = localStorage.getItem("selectedCategory") ? `${baseUrl}/price/calendar/${id}` + `?&category=${localStorage.getItem("selectedCategory")}` : `${baseUrl}/price/calendar/${id}`
        const response = await fetch(apiUrl, { method: 'GET', headers: setHeaders() });
        if (response.status) {
            return (await response.json())?.data
        }
    } catch (error) {
        console.log(error)
    }
}

export const fetchAllCountryCode = async () => {
    try {
        const apiUrl = `${baseUrl}/calendar/phoneCountryCodes`
        const response = await fetch(apiUrl, { method: 'GET', headers: setHeaders() });
        if (response.status) {
            return (await response.json())?.data
        }
    } catch (error) {
        console.log(error)
    }
}

export const fetchQuestionsByCalendar = async (id: string) => {
    try {
        const apiUrl = `${baseUrl}/question/calendar/${id}`
        const response = await fetch(apiUrl, { method: 'GET', headers: setHeaders() });
        if (response.status) {
            return (await response.json())?.data
        }
    } catch (error) {
        console.log(error)
    }
}

export const validatingPromoCode =  async(id: string, bookingid: string) => {
    try {
        const apiUrl = `${baseUrl}/promoCode/verify/${localStorage.getItem("organizationid")}`;
        const response = await fetch(apiUrl, { method: 'POST', headers: setHeaders(), body: JSON.stringify({code: id,bookingid: bookingid}) });
        if (response.status) {
            return (await response.json())?.data
        }
    } catch (error) {
        console.log(error)
    }
}

export const checkout = async (body: any, isLive = false) => {
    try {
        const apiUrl =  localStorage.getItem("selectedCategory") ? `${baseUrl}/booking/` + `?&category=${localStorage.getItem("selectedCategory")}` : `${baseUrl}/booking/`;
        const response = await fetch(apiUrl, { method: 'POST', headers: {...(setHeaders()), "x-stripe-env": isLive ? "live": "dev"}, body: JSON.stringify(body) })
        if (response.status) {
            return (await response.json())?.data
        }
        // if (response.ok) {
        //     const blob = await response.blob();
        //     const url = window.URL.createObjectURL(blob);
        //     const a = document.createElement('a');
        //     a.href = url;
        //     a.download = 'invoice.pdf';
        //     document.body.appendChild(a);
        //     a.click();
        //     a.remove();
        //     window.URL.revokeObjectURL(url);
        //     return true;
        // } else {
        //     alert('Failed to download the file');
        // }
    } catch (error) {
        console.log(error);
    }
}

export const updateBookingStatus = async (body: any, id: string, isLive: boolean) => {
    try {
        const apiUrl = `${baseUrl}/booking/status/${id}`;
        const response = await fetch(apiUrl, { method: 'PUT', headers: {...(setHeaders()), "x-stripe-env": isLive ? "live": "dev" }, body: JSON.stringify(body) })
        // if (response.status) {
        //     return (await response.json())?.data
        // }
        if (response.ok) {
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'invoice.pdf';
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
            return true;
        } else {
            alert('Failed to download the file');
        }
    } catch (error) {
        console.log(error);
    }
}


export const updatePaymentIntent = async (body: any, isLive = false) => {
    try {
        const apiUrl = `${baseUrl}/booking/update/payment-intent`;
        const response = await fetch(apiUrl, { method: 'PUT', headers: {...(setHeaders()), "x-stripe-env": isLive ? "live": "dev" }, body: JSON.stringify(body) })
        if (response.status) {
            return (await response.json())?.data
        }
    } catch (error) {
        console.log(error);
    }
}


export const fetchaddOnsByCalendarOrganisation = async (organisationId: string, calendarid: string) => {
    try {
        const apiUrl = `${baseUrl}/bundleCalendar/calendars`
        const response = await fetch(apiUrl, { method: 'POST', headers: setHeaders(), body: JSON.stringify({ organizationid: organisationId, calendarid: calendarid }) });
        if (response.status) {
            return (await response.json())?.data
        }
    } catch (error) {
        console.log(error)
    }
}


export const fetchActivityModalsListByOrganization = async () => {
    try {
        const apiUrl = `${baseUrl}/modal/`;
        const response = await fetch(apiUrl, { method: 'GET', headers: setHeaders() });
        if (response.status) {
            return (await response.json())?.data;
        }
    } catch (error) {
        console.log(error)
    }
}


export const fetchListOfCalendarsByWidget = async (id: string) => {
    try {
        const apiUrl = `${baseUrl}/modal/calendars/${id}`;
        const response = await fetch(apiUrl, { method: 'GET', headers: setHeaders() });
        if (response.status) {
            return (await response.json())?.data;
        }

    } catch (error) {
        console.log(error)
    }
}